import React from 'react';
import { FinanceOperationsForm } from 'entities/financeOperations/ui/FinanceOperationsForm';
import { IFinanceOperatorsItem, PartialFinanceOperatorsItem } from 'entities/financeOperations/types';
import { useUpdateFinanceOperationsDefaultValues } from 'entities/financeOperations/lib';
import { Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from 'entities/financeOperations/model';
import { useGetCitiesQuery } from 'features/getCities/api/getCitiesApi';
import { useDispatch } from 'react-redux';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useParams } from 'react-router';
import { useUpdateOperatorMutation } from 'entities/financeOperations/api';

type UploadFinanceOperationsFormPropsType = {
  data: IFinanceOperatorsItem;
};

export const UploadFinanceOperationsForm = ({ data }: UploadFinanceOperationsFormPropsType) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const country_id = data.country_ids[0];

  const { data: citiesList } = useGetCitiesQuery({ country_id });
  const [updateFinanceOperation] = useUpdateOperatorMutation();

  const defaultValues = useUpdateFinanceOperationsDefaultValues(data);
  const defaultCities = citiesList?.filter((city) => data.city_ids.includes(city.id)) || [];

  const updateFinanceOperationForm = useForm<PartialFinanceOperatorsItem>({
    resolver: yupResolver(validationSchema) as Resolver<PartialFinanceOperatorsItem>,
    defaultValues,
  });

  const onSubmit: SubmitHandler<PartialFinanceOperatorsItem> = (itemData) => {
    updateFinanceOperation({ data: itemData, id }).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  return citiesList ? (
    <FinanceOperationsForm
      citiesList={citiesList || []}
      citiesDefault={defaultCities}
      form={updateFinanceOperationForm}
      onSubmit={onSubmit}
    />
  ) : null;
};
